import DatabaseModel from './DatabaseModel.js';

var EmpresaMantenedora = Object.create(DatabaseModel);

EmpresaMantenedora.model = 'empresamantenedora';
EmpresaMantenedora.modelFront = 'empresasmantenedoras';

export default EmpresaMantenedora;